/**
 * The colour card's can arriving (.snusify-can, assets/snusify-product-card.css):
 * marks each can layer .is-in once its image has come in, so the tile can
 * fade the can and its shadow in together instead of showing a shadow under
 * nothing while the image is on its way.
 *
 * Nothing is hidden until this has run: it marks the cans that are already
 * in, then puts .snusify-can-fade on the root, all before the next frame.
 * From then on:
 * - an image's load event marks it; load does not bubble, so it is caught on
 *   its way down, for cans added later too - a brand row, a tab, the next
 *   page of a collection
 * - a can put into the page with its image already in hand is marked as it
 *   goes in, before it is drawn: one whose image has loaded, and one that
 *   replaces a can showing the same image - the cart drawer re-rendered
 *   after a change, the same cards sorted anew. An image with a srcset is
 *   not complete the moment it is created, even from memory, so the second
 *   check is what keeps an update from fading out what was already showing.
 */

/** @param {Element} img */
function markIn(img) {
  img.closest('.snusify-can')?.classList.add('is-in');
}

/**
 * @param {Element} node
 * @returns {Element[]} the can images in or at the node
 */
function imagesIn(node) {
  return node.matches('.snusify-can__image') ? [node] : [...node.querySelectorAll('.snusify-can__image')];
}

/** @param {Element} img */
function hasLoaded(img) {
  return img instanceof HTMLImageElement && img.complete && img.naturalWidth > 0;
}

document.addEventListener(
  'load',
  (event) => {
    const img = event.target;
    if (img instanceof HTMLImageElement && img.classList.contains('snusify-can__image')) markIn(img);
  },
  true
);

new MutationObserver((records) => {
  // What was showing among the cans just taken out, by image address.
  const showing = new Set();
  for (const record of records) {
    for (const node of record.removedNodes) {
      if (!(node instanceof Element)) continue;
      for (const img of imagesIn(node)) {
        if (img.closest('.snusify-can')?.classList.contains('is-in')) showing.add(img.getAttribute('src'));
      }
    }
  }

  for (const record of records) {
    for (const node of record.addedNodes) {
      if (!(node instanceof Element)) continue;
      for (const img of imagesIn(node)) {
        if (hasLoaded(img) || showing.has(img.getAttribute('src'))) markIn(img);
      }
    }
  }
}).observe(document.documentElement, { childList: true, subtree: true });

for (const img of document.querySelectorAll('.snusify-can__image')) {
  if (hasLoaded(img)) markIn(img);
}
document.documentElement.classList.add('snusify-can-fade');
